import type { createWorkspaceRole } from './roles';
import type { createWorkspaceMember } from './workspace-member';
import { defineRelations } from '@rstore/vue';
import { RawPolicy, RolePolicy } from './policies';
import { UserRole } from './roles';

// Role relations
export function createRoleRelations(role: ReturnType<typeof createWorkspaceRole>) {
	return defineRelations(role, ({ collection }) => ({
		users: {
			to: collection(UserRole, {
				on: {
					'MonospaceUserRole.roleId': 'MonospaceRole.id',
				},
			}),
			many: true,
		},
		policies: {
			to: collection(RolePolicy, {
				on: {
					'MonospaceRolePolicy.roleId': 'MonospaceRole.id',
				},
			}),
			many: true,
		},
	}));
}

export function createUserRoleRelations(role: ReturnType<typeof createWorkspaceRole>) {
	return defineRelations(UserRole, ({ collection }) => ({
		role: {
			to: collection(role, {
				on: {
					'MonospaceRole.id': 'MonospaceUserRole.roleId',
				},
			}),
		},
	}));
}

// Policy relations
export function createRolePolicyRelations(role: ReturnType<typeof createWorkspaceRole>) {
	return defineRelations(RolePolicy, ({ collection }) => ({
		policy: {
			to: collection(RawPolicy, {
				on: {
					'RawMonospacePolicy.id': 'MonospaceRolePolicy.policyId',
				},
			}),
		},
		role: {
			to: collection(role, {
				on: {
					'MonospaceRole.id': 'MonospaceRolePolicy.roleId',
				},
			}),
		},
	}));
}

export const RawPolicyRelations = defineRelations(RawPolicy, ({ collection }) => ({
	roles: {
		to: collection(RolePolicy, {
			on: {
				'MonospaceRolePolicy.policyId': 'RawMonospacePolicy.id',
			},
		}),
		many: true,
	},
}));

// WorkspaceMember relations
export function createWorkspaceMemberRelations(workspaceMember: ReturnType<typeof createWorkspaceMember>) {
	return defineRelations(workspaceMember, ({ collection }) => ({
		roles: {
			to: collection(UserRole, {
				on: {
					'MonospaceUserRole.userId': 'MonospaceSystemUser.id',
				},
			}),
			many: true,
		},
	}));
}
